module.exports = __webpack_public_path__ + "img/電気回路_3_9_2.2105f0fc.png";